import { createAppAsyncThunk } from "core/src/store/store.types";
import { displayApiErrorToast } from "core/src/slices/ui/useCases/display-api-error-toast/display-api-error-toast.use-case";
import axios from "axios";

export type DownloadCsvRequest = {
  baseClassName: string;
  labId?: string;
};

const downloadBlob = (blob: Blob, filename: string) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  try {
    link.click();
  } finally {
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
};

export const downloadCsv = createAppAsyncThunk<void, DownloadCsvRequest>(
  "formStep/downloadCsv",
  async ({ baseClassName, labId }, { getState, extra, dispatch, rejectWithValue }) => {
    try {
      const { selectedEtlImportUuid } = getState().etlData;
      if (!selectedEtlImportUuid) return rejectWithValue("Aucun import sélectionné");

      const response = await extra.etlClient.downloadCsv(selectedEtlImportUuid, baseClassName, labId);

      downloadBlob(new Blob([response.data], { type: "text/csv" }), `${baseClassName}.csv`);
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        dispatch(displayApiErrorToast(error.response));
        return rejectWithValue(error.response?.data?.message ?? "Erreur lors du téléchargement");
      }
      return rejectWithValue("Erreur lors du téléchargement");
    }
  }
);
